import classNames from 'classnames';
import { PureComponent } from 'react';
import './index.scss';

interface Props {
  percentage: number;
  value: number;
  max: number;
  displayLabel: boolean;
  labelWithColor: boolean;
  height: 'small' | 'medium';
  color: 'default' | 'success' | 'info' | 'danger' | 'warning';
}

export class ProgressBar extends PureComponent<Props> {
  public static defaultProps = {
    percentage: null,
    value: null,
    max: null,
    displayLabel: true,
    labelWithColor: false,
    height: 'small',
    color: 'default',
  };

  private getLabel(computedValue) {
    const { percentage, value, max } = this.props;
    return percentage !== null
      ? `${Math.round(computedValue)}%`
      : `${value}/${max}`;
  }

  public render() {
    const {
      percentage,
      value,
      max,
      displayLabel,
      labelWithColor,
      height,
      color,
    } = this.props;

    let computedValue;
    if (percentage !== null) {
      computedValue = percentage;
    } else if (value !== null && max !== null) {
      computedValue = (value / max) * 100;
    }

    if (computedValue === null) {
      return null;
    }

    const style = {
      width: `${Math.min(computedValue, 100)}%`,
    };

    return (
      <div className="ProgressBar">
        <div
          className={`ProgressBar__bar ProgressBar__bar--${height}`}
          data-value={percentage !== null ? Math.round(percentage) : value}
        >
          <div
            className={`ProgressBar__value ProgressBar__value--${color}`}
            style={style}
          />
        </div>
        {displayLabel ? (
          <div
            className={classNames(
              'ProgressBar__label',
              labelWithColor && `ProgressBar__label--${color}`
            )}
          >
            <span>{this.getLabel(computedValue)}</span>
          </div>
        ) : null}
      </div>
    );
  }
}
